<template>
    <div id="profile-edit">
        <h4>Edit Profile</h4>
    </div>
</template>

<script>
    export default {}
</script>